import ImageGallery from './ImageGallery';

export * from './types';

export default ImageGallery;
